import { Directive, inject } from '@angular/core'
import { ElderEnumTranslationService, ElderSelectComponent } from '@elderbyte/ngx-starter'
import { ScrapFinishedSelector } from './scrap-finished-selector'

@Directive({
  selector: '[appScrapFinishedSelector]',
})
export class ScrapFinishedSelectorDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private select = inject(ElderSelectComponent)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.select.placeholder = 'context.selection'
    this.select.displayProperty = 'displayValue'
    const enumTranslationService = inject(ElderEnumTranslationService)
    this.select.dataSource = enumTranslationService.enumDataSource(
      ScrapFinishedSelector,
      'scrap.finished-selector'
    )
  }
}
